import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "galleypreference"
    }}>{`GalleyPreference`}</h1>
    <p>{`Galley preferences.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the GalleyPreference (a Application or Document).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`backgroundColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The background color, specified either as an array of three doubles, each in the range 0 to 255 and representing R, G, and B values, or as an InCopy UI color. . Can return: Array of 3 Reals (0 - 255) or InCopyUIColors enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`blinkCursor`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the cursor blinks.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CursorTypes `}<strong parentName="p">{`cursorType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The cursor type for galley and story views.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`smoothText`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, galley text is anti-aliased.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`textColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The text color, specified either as an array of three doubles, each in the range 0 to 255 and representing R, G, and B values, or as an InCopy UI color. Can return: Array of 3 Reals (0 - 255) or InCopyUIColors enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`showDepthRuler`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, displays the depth ruler.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`AntiAliasType `}<strong parentName="p">{`antiAliasType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The type of text anti-aliasing to use in story and galley views.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`showParagraphStyleNames`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, show paragraph style names.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`LineSpacingType `}<strong parentName="p">{`lineSpacingValue`}</strong>{` `}</p>
      <p parentName="blockquote">{`Amount of spacing between lines.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`displayFont`}</strong>{` `}</p>
      <p parentName="blockquote">{`Font family name to use for text display.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`displayFontSize`}</strong>{` `}</p>
      <p parentName="blockquote">{`Size to use for text display.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`infoColumnWidth`}</strong>{` `}</p>
      <p parentName="blockquote">{`Info column width.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`showInfoColumn`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, display the Info column.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`showParagraphBreakMarks`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, show paragraph break marks.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the GalleyPreference.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`GalleyPreference `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      